import React from 'react';

/**
 * マスタ検索フォームのプロパティ定義
 */
interface MasterSearchFormProps {
  isFarmer: boolean;                                                                     // 生産者カテゴリを検索中かどうかのフラグ
  filters: { code: string; name: string };                                               // 一般的な検索条件（コード・名称）
  setFilters: React.Dispatch<React.SetStateAction<{ code: string; name: string }>>;      // 一般フィルタの更新関数
  sellerFilter: { code: string; name: string };                                          // 売手フィルタ（生産者検索時のみ使用）
  setSellerFilter: React.Dispatch<React.SetStateAction<{ code: string; name: string }>>; // 売手フィルタの更新関数
  onClear: () => void;                                                                   // クリアボタン押下時のコールバック
  onSearch: () => void;                                                                  // 検索ボタン押下時のコールバック
}

// デザインの統一感を保つための定数
const FIELD_WIDTH_CODE = 'w-[100px]'; // コード入力欄の幅
const FIELD_WIDTH_NAME = 'w-[180px]'; // 名称入力欄の幅

/**
 * マスタ検索ダイアログ内の検索入力エリアを担当するコンポーネント
 */
export const MasterSearchForm = ({
  isFarmer,
  filters,
  setFilters,
  sellerFilter,
  setSellerFilter,
  onClear,
  onSearch,
}: MasterSearchFormProps) => {
  return (
    // 背景色をわずかに変えて、検索結果エリアと視覚的に分離
    <div className="flex-none p-5 bg-slate-50/50 border-b border-slate-100">
      <div className="flex flex-wrap items-end gap-x-4 gap-y-3">
        
        {/* --- 生産者（Farmer）カテゴリの場合のみ、売手情報のフィルタを表示 --- */}
        {isFarmer && (
          <>
            <div className="flex flex-col gap-1">
              <span className="text-sm font-bold text-slate-500 ml-1">売手コード</span>
              <input 
                type="text" 
                value={sellerFilter.code}
                disabled={true}
                onChange={(e) => setSellerFilter(p => ({...p, code: e.target.value}))}
                className={`border border-slate-300 rounded px-3 py-1.5 text-sm outline-none focus:border-indigo-500 bg-slate-200 text-slate-600 shadow-sm ${FIELD_WIDTH_CODE}`} 
              />
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-sm font-bold text-slate-500 ml-1">売手名</span>
              <input 
                type="text" 
                value={sellerFilter.name} 
                disabled={true}
                onChange={(e) => setSellerFilter(p => ({...p, name: e.target.value}))}
                className={`border border-slate-300 rounded px-3 py-1.5 text-sm outline-none focus:border-indigo-500 bg-slate-200 text-slate-600 shadow-sm ${FIELD_WIDTH_NAME}`} 
              />
            </div>
          </>
        )}

        {/* --- 共通の検索フィルタ（コード・名称） --- */}
        <div className="flex flex-col gap-1">
          {/* カテゴリによってラベルを出し分ける（生産者の場合は明示的に表示） */}
          <span className="text-sm font-bold text-slate-500 ml-1">
            {isFarmer ? '生産者コード' : 'コード'}
          </span>
          <input 
            type="text" 
            value={filters.code} 
            onChange={(e) => setFilters(p => ({...p, code: e.target.value}))}
            className={`border border-slate-300 rounded px-3 py-1.5 text-sm outline-none focus:border-indigo-500 bg-white shadow-sm ${FIELD_WIDTH_CODE}`} 
          />
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-sm font-bold text-slate-500 ml-1">
            {isFarmer ? '生産者名' : '名称'}
          </span>
          <input 
            type="text" 
            value={filters.name} 
            onChange={(e) => setFilters(p => ({...p, name: e.target.value}))}
            className={`border border-slate-300 rounded px-3 py-1.5 text-sm outline-none focus:border-indigo-500 bg-white shadow-sm ${FIELD_WIDTH_NAME}`} 
          />
        </div>

        {/* --- アクションボタンエリア --- */}
        <div className="flex gap-2 ml-auto pt-1">
          <button 
            type="button" 
            onClick={onSearch} 
            className="bg-slate-700 text-white px-4 py-1.5 rounded text-sm font-bold hover:bg-slate-800 shadow-sm transition-colors"
          >
            検索
          </button>
          <button 
            type="button" 
            onClick={onClear} 
            className="bg-white border border-slate-300 text-slate-600 px-4 py-1.5 rounded text-sm font-bold hover:bg-slate-50 transition-colors"
          >
            クリア
          </button>
        </div>
      </div>
    </div>
  );
};